import { TextField } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import RegularButton from "../../components/Buttons/RegularButton";
import { useLoginUserMutation } from "../../redux/services/authApi";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { getUserData } from "../../redux/slices/authSlice";
import { useFindCustomerDetailByIdMutation } from "../../redux/services/customerService";
import { useForgotPasswordMutation } from "../../redux/services/userApi";
import MuiAlert from "../../pages/MuiAlert/MuiAlert";
import Loading from "../../pages/commons/Loading";

type Props = {};

const SignInSchema = Yup.object().shape({
  username: Yup.string().max(40).required(" Email is required"),
});
const ForgetPassword = (props: Props) => {
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [forgetPassword, forgetPasswordResponse] = useForgotPasswordMutation();
  const navigate = useNavigate();
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const handleLogin = (values: any) => {
    forgetPassword({
      email: values.username,
      category: "UTCUST",
    });
  };

  useEffect(() => {
    if (forgetPasswordResponse.isSuccess) {
      if (forgetPasswordResponse.data == true) {
        setStatusCode({
          type: "success",
          code: "SERVICEPROVIDER_FORGET_PASSWORD",
        });
        setIsAlertVisible(true);
        setTimeout(() => {
          setIsAlertVisible(false);
        }, 5000);
      }
    }
    if (forgetPasswordResponse.isError) {
      const errorData: any = forgetPasswordResponse.error;
      const errorCode: any =
        errorData?.data && errorData.data.serviceErrors[0].errorCode;
      setStatusCode({
        type: "error",
        code: errorCode,
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [forgetPasswordResponse.isSuccess, forgetPasswordResponse.error]);

  return (
    <div className="bg-[#F9F4EF] w-full">
      <div className="relative w-full flex lg:hidden justify-center items-center pt-10">
        <img
          src={require("../../assets/login.png")}
          className="w-full sm:w-[500px] md:w-[600px]  md:max-h-[500px] object-cover"
          alt="Auth Illustration"
        />

        {/* Overlayed Text (Responsive for Mobile & Tab) */}
        <div className="absolute top-12 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center w-full px-4">
          <h2 className="text-xl sm:text-2xl md:text-4xl text-black">WEEKEND GETAWAY</h2>
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold text-black mt-2">
            Grab Up to 40% OFF*
          </h1>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row h-screen">
        {/* Form Section */}
        <div className="w-full lg:w-[40%] flex flex-col justify-center items-center p-4">
          <div className="max-w-[400px] w-full">
            {isAlertVisible && (
              <MuiAlert severity={statusCode?.type} messageType={statusCode?.code} />
            )}
            <div className="text-center">
              <h1 className="text-4xl font-bold text-gray-700">
                ca<span className="font-extrabold">RENT</span>al
              </h1>
              <h2 className="text-2xl font-semibold text-black mt-2">Forgot Password?</h2>
            </div>
            <Formik
              enableReinitialize
              initialValues={{
                username: "",
              }}
              validationSchema={SignInSchema}
              onSubmit={handleLogin}
            >
              {({
                handleBlur,
                handleChange,
                handleSubmit,
                values,
                touched,
                errors,
              }) => (
                <div className="flex flex-col">
                  <div className="mt-3">
                    <TextField
                      label="Enter your email address"
                      variant="outlined"
                      size="small"
                      type="text"
                      id="username"
                      name="username"
                      value={values.username}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter your email"
                      error={Boolean(touched.username && errors.username)}
                      helperText={touched.username && errors.username}
                      className="w-full mt-1"
                      sx={{
                        backgroundColor: "#E2E2E2",
                        borderRadius: "30px",
                        mb: 2,
                        height: "45px", // Slightly reduced height for a compact look
                        "& .MuiInputBase-root": {
                          display: "flex",
                          alignItems: "center", // Centers input text vertically
                          height: "100%",
                          padding: "0 12px", // Reducing padding inside input container
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "30px",
                          height: "100%",
                          "& input": {
                            padding: "6px 8px", // Reduced padding inside input field
                          },
                          "& fieldset": { borderColor: "transparent" },
                          "&:hover fieldset": { borderColor: "transparent" },
                          "&.Mui-focused fieldset": { borderColor: "transparent" },
                        },
                        "& .MuiInputLabel-root": {
                          top: "50%",
                          left: "12px", // Moves label closer to start
                          transform: "translateY(-50%)", // Centers label vertically
                        },
                        "& .MuiInputLabel-shrink": {
                          top: 6, // Moves label up when focused
                          transform: "translateY(-100%) scale(0.75)",
                        },
                        "& .MuiFormHelperText-root": {
                          position: "absolute",
                          bottom: "-18px", // Adjusted for better spacing
                          fontSize: "12px",
                          color: "red",
                        },
                      }}
                    />
                  </div>
                  <div className="lg:flex sm:flex-row items-center gap-5 mt-5 ">
                    <RegularButton
                      onClick={() => {
                        handleSubmit();
                      }}
                      className="w-[100%] md:w-[400px]"
                      title={"Send password"}
                    />
                  </div>
                </div>
              )}
            </Formik>
            <p className="flex justify-center mb-0 gap-2 text-gray-500 py-6 cursor-default">
              Click here to{" "}
              <span
                className="text-blue-500 cursor-pointer"
                onClick={() => {
                  navigate("/profile/auth/login");
                }}
              >
                SignIn
              </span>
            </p>
          </div>
        </div>
        {/* Image Section */}
        <div className="relative w-full lg:w-[60%] hidden lg:flex justify-center items-center p-4">
          <img
            src={require("../../assets/login.png")}
            className="w-[600px] max-h-[300px] md:max-h-[500px] object-cover"
            alt="Auth Illustration"
          />

          {/* Overlayed Text (Centered Properly) */}
          <div className="absolute top-28 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center w-full px-4">
            <h2 className="text-4xl text-black whitespace-nowrap">WEEKEND GETAWAY</h2>
            <h1 className="text-5xl font-bold text-black mt-2 whitespace-nowrap">
              Grab Up to 40% OFF*
            </h1>
          </div>
        </div>
        {forgetPasswordResponse.isLoading ? <Loading /> : null}
      </div>
    </div>
  );
};

export default ForgetPassword;
